import { useContentfulEntry } from '../hooks/useContentfulEntry';

function SingleItemComponent(props) {
  const { id, children } = props;
  const { entry, loading, error } = useContentfulEntry(id);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading content.</div>;
  if (!entry) return null;

  // If you want to render children with the fetched entry:
  return typeof children === 'function'
    ? children({ entry, loading, error })
    : null;
}

export default SingleItemComponent;
